module.exports = __webpack_public_path__ + "static/media/mp.8a731cbc.svg";